/**
 * Insignia del ambiente: produccion en rojo, los servidores compartidos (staging
 * y el servidor de desarrollo) en ambar, el resto neutro.
 *
 * Esta siempre a la vista (menu, barra movil, login): en una herramienta con
 * reproceso manual, saber si se esta mirando produccion no puede depender de la
 * memoria. Trae dos textos —el nombre y una version corta para el menu
 * contraido— y el CSS decide cual se ve; el lector de pantalla lee el nombre.
 */
import type { ReactElement } from 'react';
import {
  classifyEnvironment,
  environmentDisplayName,
  environmentShortName,
} from '../lib/environment';

export interface EnvironmentBadgeProps {
  /** Etiqueta cruda de `VITE_ENVIRONMENT_LABEL`. */
  readonly label: string;
  readonly className?: string;
}

export function EnvironmentBadge({ label, className }: EnvironmentBadgeProps): ReactElement {
  const kind = classifyEnvironment(label);
  const name = environmentDisplayName(label);
  const classes = `env-badge env-badge--${kind}${className === undefined ? '' : ` ${className}`}`;

  return (
    <span className={classes} title={`Ambiente: ${name}`}>
      <span className="visually-hidden">Ambiente: </span>
      <span className="env-badge__name">{name}</span>
      <span className="env-badge__short" aria-hidden="true">
        {environmentShortName(label)}
      </span>
    </span>
  );
}
